import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import SiteHeader from '@homeaway/react-site-header';
import {getIsMobile, getSiteName} from '../../selectors/system';

// Abacus: waterfall
import {WATERFALL_AB, AsyncHeader} from '../../abacus/waterfall';
import withAbacusTestValuesAsProps from '../../abacus/with-abacus-test-values-as-props/with-abacus-test-values-as-props';

function mapStateToProps(state) {
    return {
        siteName: getSiteName(state),
        fullLocale: state.system.fullLocale,
        isMobile: getIsMobile(state),
        header: state.header,
        currency: state.system.currency
    };
}

export function Header({header, isMobile, siteName, fullLocale, currency}) {
    return (
        <SiteHeader
            {...header}
            dataUrl="/traveler/scratchpad/api/header"
            isMobile={isMobile}
            siteName={siteName}
            fullLocale={fullLocale}
            currencyCode={currency}
            withoutCountryLanguageSelector={false}
            withoutCurrencySelector={false}
        />
    );
}

// Abacus: waterfall
export function HeaderContainer({waterfallTestValue, ...rest}) {
    if (waterfallTestValue > 0) {
        return <AsyncHeader {...rest} />;
    }
    return <Header {...rest} />;
}

export default compose(
    connect(mapStateToProps),
    withAbacusTestValuesAsProps({
        [WATERFALL_AB]: 'waterfallTestValue'
    })
)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/universal/components/Header/Header.js